var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InfoDetails',{attrs:{"data":_vm.reportDetails},scopedSlots:_vm._u([{key:"time",fn:function(){return [_c('InfoTime',{attrs:{"data":_vm.reportDetails}})]},proxy:true}])},[(_vm.fileUrl)?_c('FileEntry',{staticClass:"file-entry--report",attrs:{"url":_vm.fileUrl}}):_vm._e()],1),_c('Disclaimer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }